import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

function CapsuleLogo() {
  return (
    <div className="capsule-icon">
      <div className="left"></div>
      <div className="right"></div>
    </div>
  );
}

function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-navy-900 text-white py-6">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/login" className="inline-flex items-center text-sm text-navy-300 hover:text-white mb-4">
            <ArrowLeft className="w-4 h-4 mr-1" /> Back to Login
          </Link>
          <div className="flex items-center gap-3">
            <CapsuleLogo />
            <div>
              <h1 className="text-2xl font-heading font-bold">
                <span className="text-mint-400">Pharma</span>
                <span className="text-white">Buddy</span>
              </h1>
              <p className="text-xs text-navy-400 italic">Pharmacist's Most Reliable Partner</p>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-heading font-bold text-navy-900 mb-2">Terms of Service</h1>
          <p className="text-sm text-slate-500 mb-8">Last Updated: February 2026</p>

          <div className="prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">1. Acceptance of Terms</h2>
              <p className="text-slate-600 leading-relaxed">
                By creating a PharmaBuddy account, you agree to these terms. This is a legally binding agreement between you (the "User") and PharmaBuddy.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">2. User Responsibilities</h2>
              <ul className="list-disc list-inside space-y-2 text-slate-600">
                <li><strong>Pharmacist Supervision:</strong> You warrant that all medicine dispensing is done under the personal supervision of a Registered Pharmacist as per the Pharmacy Act, 1948.</li>
                <li><strong>Accuracy:</strong> You are responsible for the accuracy of HSN codes and GST rates applied to products.</li>
                <li><strong>Lawful Use:</strong> You will not use the software to facilitate the sale of banned or illegal substances.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">3. Subscription Plans & Payments</h2>
              <div className="space-y-4">
                <div className="bg-slate-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-navy-900 mb-2">Pro Plan (₹999/month)</h3>
                  <p className="text-slate-600">Limited to 999 unique customers per month. Exceeding this limit will trigger a prompt to upgrade.</p>
                </div>
                <div className="bg-slate-50 p-4 rounded-lg">
                  <h3 className="font-semibold text-navy-900 mb-2">Pro Plus Plan (₹1999/month)</h3>
                  <p className="text-slate-600">Unlimited customers and access to the HIMS integration bridge.</p>
                </div>
                <p className="text-slate-600">
                  <strong>Refunds:</strong> Subscriptions are non-refundable but can be canceled at any time to prevent the next billing cycle.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">4. Service Availability</h2>
              <p className="text-slate-600 leading-relaxed">
                While we strive for 99.9% uptime, PharmaBuddy is not liable for business losses during rare server downtimes or internet outages at the user's end.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-navy-900 mb-3">5. Termination</h2>
              <p className="text-slate-600 leading-relaxed">
                PharmaBuddy reserves the right to terminate accounts found in violation of the Drugs and Cosmetics Act or those found tampering with the SaaS metering logic.
              </p>
            </section>

            <section className="mb-8 p-4 bg-amber-50 border border-amber-200 rounded-lg">
              <h2 className="text-lg font-semibold text-amber-800 mb-2">Important Notice</h2>
              <p className="text-amber-700 text-sm">
                By using PharmaBuddy, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our Privacy Policy in compliance with the Digital Personal Data Protection (DPDP) Act, 2023.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t">
            <Link to="/login">
              <Button className="bg-mint-600 hover:bg-mint-700">
                <ArrowLeft className="w-4 h-4 mr-2" /> Return to Login
              </Button>
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-slate-500">
        <div className="flex items-center justify-center gap-4">
          <Link to="/privacy" className="hover:text-mint-600">Privacy Policy</Link>
          <span>•</span>
          <Link to="/terms" className="text-mint-600">Terms of Service</Link>
          <span>•</span>
          <span>© 2026 PharmaBuddy</span>
        </div>
      </footer>
    </div>
  );
}

export default TermsOfService;
